module.exports = __webpack_public_path__ + "static/media/Swashakthi-SHG-case-study-1.7096886c.webp";